import React, { useContext } from 'react';
import USOverviewImage from 'assets/starterImg.png';
import { Header } from 'components';
import { WppTypography, WppCard } from '@wppopen/components-library-react';
import { V3AssetPathContext } from 'App';
import { getV3AssetPath } from 'utils/V3AssetPathContext';
import styles from './StartPage.module.scss';
import { Localization } from 'utils';
import { LocalizationCard } from './LocalizationCard/LocalizationCard';
import { RedirectButton } from 'components/RedirectButton/RedirectButton';
import { TestIds } from 'utils';

const {
    Main,
    MainContent,
    MainContentGrid,
    MainContentGridDescription,
    MainContentGridLink,
    MainContentGridImg,
} = styles;

export const StartPage = () => {
    const { isV3, assetPath } = useContext(V3AssetPathContext);
    const currentImage = USOverviewImage;

    return (
        <div className={Main} data-testid={TestIds.overview.containers}>
            <Header title={'Segment Opportunity Simulator'} isBackButtonShown={false}>
                <RedirectButton />
            </Header>
            <div className={MainContent}>
                <WppCard size="2xl">
                    <div className={MainContentGrid}>
                        <div
                            className={MainContentGridDescription}
                            data-testid={TestIds.overview.containers.infoSection}
                        >
                            <WppTypography type="2xl-heading">Overview</WppTypography>
                            <WppTypography type="m-body">
                                Brands recognize the importance of inclusivity, and understand the
                                gap in their access to underserved audiences. However, they are
                                unsure how to navigate commercial realities. Data is fragmented and
                                the future is uncertain. The scale of the missed business
                                opportunity isn`t visible in a data driven, easily digestible
                                format.
                            </WppTypography>
                            <div>
                                <WppTypography
                                    type="s-body"
                                    data-testid={TestIds.overview.containers.mail}
                                >
                                    For support or more information email:
                                    <a
                                        href="mailto:growth@choreograph.com"
                                        className={MainContentGridLink}
                                    >
                                        <br />
                                        strategicInsights@choreograph.com
                                    </a>
                                </WppTypography>
                            </div>
                            <img
                                src={getV3AssetPath(currentImage, isV3, assetPath)}
                                alt="img"
                                className={MainContentGridImg}
                            />
                        </div>
                        <LocalizationCard
                            localization={Localization.UK}
                            title="UK Projections"
                            ages="2025-2061"
                            description="The tool quantifies the evolution of demographics and
                                        category spend in the UK, highlighting the growth of the
                                        purchase power of the underserved audiences. Our
                                        first-to-market scenario playing feature translates the
                                        paths of action into the business opportunities they present
                                        in a rapidly changing population structure; now, next year,
                                        and in the decades to follow."
                            compliance="Contains public sector information licensed under the Federal Open Data Policy."
                            size="xl"
                        />
                        <LocalizationCard
                            localization={Localization.US}
                            title="US Projections"
                            ages="2025-2040"
                            description="Segment Opportunity Simulator US provides market value and
                                        size projections for US multicultural segments, for
                                        engagement strategy planning. The product allows users to
                                        discover new opportunities in the US rapidly changing
                                        multicultural consumer landscape and unlock insights into
                                        population growth and future category spend by ethnicity,
                                        age, gender, income and geography."
                            compliance="Contains public sector information licensed under the Open Government Licence"
                            size="xl"
                        />
                    </div>
                </WppCard>
            </div>
        </div>
    );
};
